import React from 'react';
import { UniversalJiraList } from '../../../../common/UniversalJiraList';

export const JiraWorklogsList = ({ data, selectedMonth, selectedYear }) => {
  if (!data) {
    return <p>Brak wyników dla bieżących ustawień!</p>;
  }

  return (
    <UniversalJiraList
      items={data.result.worklogs}
      config={{
        filterByMonth: true,
        selectedMonth,
        selectedYear,
        getKey: (item) => item.key,
        getTitle: (item) => `${item.key}: ${item.summary}`,
        getLabels: (item) => item.labels,
        getLink: (item) => item.link,
        getStatus: (item) => item.status.name,
        getReporterLabel: () => 'Zgłaszający:',
        getReporter: (item) => item.reporter,
        getWorklogs: (item) => item.worklogs,
        getOriginalEstimate: (item) => item.timeTracking.originalEstimate,
        getLoggedTimeLabel: () => 'Czas zarejestrowany w danym miesiącu:',
      }}
    />
  );
};
